import { useLocation, useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Table, TableHead, TableRow, TableContainer, Paper, TableCell, TableBody } from "@mui/material";

const CampaignHistoryViewPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const campaign = location.state?.campaign;

    const handleClose = () => navigate(-1); // go back

    if (!campaign) return null;
    const headings = [
        'SL',
        'Customer Email',
        'Status',
        'Started At',
        'Description',
    ];
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    return (
        <Dialog open={true} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>{campaign.campaignName || "Campaign Details"}</DialogTitle>
            <DialogContent>

                {/* Campaign Info */}
                <Typography><strong>CampaignType:</strong> {campaign.campaignType}</Typography>
                <Typography><strong>Store:</strong> {campaign.storeId?.storeName || campaign.storeName || (typeof campaign.storeId === 'string' ? campaign.storeId : 'N/A')}</Typography>
                <Typography><strong>Description:</strong> {campaign.description || "N/A"}</Typography>
                <Typography><strong>From:</strong> {process.env.EMAIL_USER || "N/A"}</Typography>
                <Typography>
                    <strong>To:</strong> {campaign.customerHistory?.map(c => c.email).join(", ")}
                </Typography>
                {/* Campaign Assets */}
                {campaign.campaignAssets?.map((asset, idx) => (
                    <div key={idx} style={{ marginTop: 10 }}>
                        {asset.assetType === "Image" && <img src={asset.url} alt={asset.description} style={{ maxWidth: "100%" }} />}
                        {asset.assetType === "PDF" && <a href={asset.url} target="_blank">📄 {asset.description}</a>}
                        {asset.assetType === "Video" && <a href={asset.url} target="_blank">🎥 {asset.description}</a>}
                        {asset.assetType === "Link" && <a href={asset.url} target="_blank">🔗 {asset.url}</a>}
                        {asset.assetType === "Other" && <p>📦 {asset.description}: <a href={asset.url} target="_blank">{asset.url}</a></p>}
                    </div>
                ))}
                <TableContainer component={Paper} className="history-table"
                    sx={{
                        borderRadius: '12px',
                        maxHeight: 400,   // fixed height for table container
                        overflowY: "auto",
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        marginTop: '10px'
                    }}>
                    {/* Email History Table */}
                    <Table stickyHeader
                        className="custom-product-table"
                        sx={{
                            '& td, & th': {
                                border: 'none',
                            },
                            border: 'none',
                        }}>
                        <TableHead>
                            <TableRow >
                                {headings.map((heading, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            border: 'none',
                                            padding: '12px 16px',
                                            textAlign: 'center',
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: '#3C0008',
                                            zIndex: 1,

                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '4px',
                                                color: '#ffffff',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                            }}
                                        >
                                            {heading}
                                            <span style={{ fontSize: '10px', color: '#ffffff' }}>▲▼</span>
                                        </Typography>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {campaign.customerHistory?.length > 0 ? (
                                campaign.customerHistory.map((cust, idx) => (
                                    <TableRow key={cust.customerId}>
                                        <TableCell><Typography sx={commonCellStyle}>{idx + 1}</Typography></TableCell>
                                        <TableCell><Typography sx={commonCellStyle}>{cust.email}</Typography></TableCell>
                                        <TableCell><Typography sx={commonCellStyle}>{cust.status}</Typography></TableCell>
                                        <TableCell><Typography sx={commonCellStyle}>{new Date(cust.startedAt).toLocaleString()}</Typography></TableCell>
                                        <TableCell><Typography sx={commonCellStyle}>{campaign.description || "-"}</Typography></TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} style={{ textAlign: "center" }}>No customer history found.</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={handleClose} 
                    sx={{ 
                        bgcolor: '#3C0008', 
                        color: '#ffffff', 
                        textTransform: 'none',
                        px: 3,
                        '&:hover': { bgcolor: '#6d000e' }
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CampaignHistoryViewPage;
